var map = {
	"./CA/seal.png": 1651,
	"./CA/seal.svg": 1077,
	"./CA/seal_color.png": 1652,
	"./CA/seal_reversed.svg": 1078,
	"./CA/sos-logo.png": 1653,
	"./ID/seal.png": 1654,
	"./ID/seal.svg": 1079,
	"./ID/seal_color.png": 1655,
	"./ID/seal_reversed.svg": 1080,
	"./ID/sos-logo.png": 1656,
	"./MT/mt-sos-logo.png": 1657,
	"./MT/seal.png": 1658,
	"./MT/seal.svg": 1081,
	"./MT/seal_color.png": 1659,
	"./MT/seal_white.png": 1660,
	"./ND/seal.svg": 1082,
	"./SOS/seal.svg": 1083
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;



//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals ^\.\/.*$
// module id = 221
// module chunks = 0